import TernaryIndicator from "./TernaryIndicator";

export default TernaryIndicator